import React from 'react';
import { Badge as MuiBadge, BadgeProps as MuiBadgeProps } from '@mui/material';
import { StyledBadge } from './Badge.style';

export interface BadgeProps extends MuiBadgeProps {
  /**
   * The content rendered within the badge
   */
  badgeContent?: React.ReactNode;
  /**
   * The color of the badge
   */
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info' | 'default';
  /**
   * Whether the badge should pulse
   */
  pulse?: boolean;
  /**
   * Whether the badge should be invisible
   */
  invisible?: boolean;
  /**
   * Maximum count to show
   */
  max?: number;
  /**
   * Whether to show zero
   */
  showZero?: boolean;
  /**
   * The variant of the badge
   */
  variant?: 'standard' | 'dot';
}

export const Badge: React.FC<BadgeProps> = ({
  children,
  badgeContent,
  color = 'primary',
  pulse = false,
  invisible = false,
  max = 99,
  showZero = false,
  variant = 'standard',
  ...props
}) => {
  return (
    <StyledBadge
      badgeContent={badgeContent}
      color={color}
      invisible={invisible}
      max={max}
      showZero={showZero}
      variant={variant}
      pulse={pulse}
      {...props}
    >
      {children}
    </StyledBadge>
  );
}; 